<template>
  <div class="addfactory">
    <div class="title">
      工厂源管理 <span>{{titlename}}工厂源</span>
    </div>
    <div class="main">
      <div class="addFactoryInfo">{{titlename}}工厂源</div>

      <div class="factoryContent">
        <div class="factorylist">
          <label for="factorynum"><span>*</span>工厂名称</label>
          <el-input size="small"
                    v-model="factoryInfo.name"
                    placeholder="输入工厂名称"></el-input>
        </div>
        <div class="factorylist">
          <label for="factoryname">
            <span>*</span>工厂地址
          </label>
          <el-cascader :focus="changeAddr"
                       size="small"
                       class="addressStyle"
                       @active-item-change="handleItemChange"
                       :options="options"
                       v-model="addressFrom"
                       @change="handleChangeFrom"
                       placeholder="省市区">
          </el-cascader>
          <el-input size="small"
                    class="areaaddress"
                    v-if="changeAddr"
                    v-model="address"
                    readonly
                    @focus="handleAddrChangeClick"></el-input>
        </div>
        <div class="factorylist address">
          <el-input size="small"
                    v-model="factoryInfo.address"
                    placeholder="详细地址"></el-input>
          <el-button size="small"
                     style="margin-left:10px;"
                     @click="handleConfirmClick">确定</el-button>
        </div>
        <div class="factorylist">
          <label for="factorynum"><span>*</span>工厂经度</label>
          <el-input size="small"
                    readonly
                    v-model="factoryInfo.lng"
                    placeholder="工厂经度"></el-input>
        </div>
        <div class="factorylist">
          <label for="factorynum"><span>*</span>工厂纬度</label>
          <el-input size="small"
                    readonly
                    v-model="factoryInfo.lat"
                    placeholder="工厂纬度"></el-input>
        </div>
        <div class="factorylist">
          <label for="factorynum"><span>*</span>厂商地址地图</label>
          <div class="map_content">
            <div id="container"></div>
          </div>
        </div>
        <div class="factoryBtn">
          <button class="save"
                  @click="handleAddFactoryClick">
            保存
          </button>
          <button @click="handleCancelClick"
                  class="cancel">
            取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://a.amap.com/jsapi_demos/static/demo-center/js/demoutils.js"></script>
<script type="text/javascript" src="https://webapi.amap.com/maps?v=1.4.14&key=6656a8e9810da0328783e4c374223568&plugin=AMap.Geocoder"></script>
<script>
import {
  provinceList,
  cityList,
  areaList,
  addFactory,
  getFactory,
  updateFactory
} from 'apis/index'
// import VueAMap from 'vue-amap'
// let amapManager = new VueAMap.AMapManager()
export default {
  name: 'addfactory',
  data () {
    return {
      factoryInfo: {
        address: '',
        lng: '',
        lat: '',
        name: ''
      },
      id: '',
      options: [],
      addressFrom: [],
      from: '',
      address: '',
      zoom: 10,
      // amapManager,
      data: {},
      changeAddr: false,
      titlename: '添加'
    }
  },
  methods: {
    async initData () { // 省市区三级联动
      let ret = await provinceList()
      if (ret.data.code === 0) {
        let newData = JSON.stringify(ret.data.data.result)
        newData = newData.replace(/provinceCode/g, 'value')
        newData = newData.replace(/provinceName/g, 'label')
        this.options = JSON.parse(newData)
        this.options.forEach((item, index) => {
          this.$set(this.options[index], 'children', [])
        })
      }
    },
    async handleItemChange (val) {
      if (val.length === 1) { // 请求省，且只第一次才发请求
        let provinceCode = val[0]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && !this.options[j].children.length) {
            let ret = await cityList({ provinceCode })
            if (ret.data.code === 0) {
              let newData = JSON.stringify(ret.data.data.result)
              newData = newData.replace(/cityCode/g, 'value')
              newData = newData.replace(/cityName/g, 'label')
              let newCity = JSON.parse(newData)
              newCity.forEach(item => {
                item.children = []
              })
              this.$set(this.options[j], 'children', newCity)
              break
            }
          }
        }
      }
      if (val.length === 2) { // 请求市区，且只第一次才发请求
        let provinceCode = val[0]
        let cityCode = val[1]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && this.options[j].children.length) {
            for (let k = 0; k < this.options[j].children.length; k++) {
              if (this.options[j].children[k].value === cityCode && !this.options[j].children[k].children.length) {
                let ret = await areaList({ cityCode })
                if (ret.data.code === 0) {
                  if (!ret.data.data.result.length) { // 修复中山市/东莞市等三级为空数组的情况
                    let newArea = [{
                      value: this.options[j].children[k].value,
                      label: this.options[j].children[k].label
                    }]
                    this.$set(this.options[j].children[k], 'children', newArea)
                    break
                  }
                  let newData = JSON.stringify(ret.data.data.result)
                  newData = newData.replace(/areaCode/g, 'value')
                  newData = newData.replace(/areaName/g, 'label')
                  let newArea = JSON.parse(newData)
                  this.$set(this.options[j].children[k], 'children', newArea)
                  break
                }
              }
            }
          }
        }
      }
    },
    getAddressText (value) { // 获取地址
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value === value[0]) {
          this.address = this.options[i].label
          let city = this.options[i].children
          for (var j = 0; j < city.length; j++) {
            if (city[j].value === value[1]) {
              this.address += ',' + city[j].label
              let area = city[j].children
              for (var k = 0; k < area.length; k++) {
                if (area[k].value === value[2]) {
                  this.address += ',' + area[k].label
                }
              }
            }
          }
        }
      }
      // console.log(this.options)
    },
    handleChangeFrom (value) {
      this.getAddressText(value)
      this.from = this.address
    },
    handleAddrChangeClick () {
      this.changeAddr = false
    },
    getData (id) { // 获取数据
      getFactory({
        factoryId: id
      }).then(res => {
        if (res.data.code === 0) {
          // console.log(res)
          this.factoryInfo = {
            name: res.data.data.factoryname,
            lat: res.data.data.lat,
            lng: res.data.data.lng,
            address: res.data.data.departureaddress
          }
          this.address = res.data.data.departurename
          // this.handleBlurChange()
          console.log(res)
          let address = res.data.data.departurename + res.data.data.departureaddress
          this.showMap(address)
        }
      })
    },
    handleAddFactoryClick () {
      if (!this.address | !this.factoryInfo.address | !this.factoryInfo.lng | !this.factoryInfo.lat | !this.factoryInfo.name) {
        this.$message({
          message: '*为必选内容',
          type: 'warning'
        })
      } else {
        if (this.id) {
          // console.log('修改')
          updateFactory({
            id: this.id,
            factoryname: this.factoryInfo.name,
            lat: this.factoryInfo.lat,
            lng: this.factoryInfo.lng,
            departurename: this.address,
            departureaddress: this.factoryInfo.address
          }).then(res => {
            if (res.data.code === 0) {
              this.$router.push({ path: '/manage/factory' })
            }
          })
        } else {
          addFactory({ // 添加
            factoryname: this.factoryInfo.name,
            lat: this.factoryInfo.lat,
            lng: this.factoryInfo.lng,
            departurename: this.address,
            departureaddress: this.factoryInfo.address
          }).then(res => {
            // console.log(res)
            if (res.data.code === 0) {
              this.$router.push({ path: '/manage/factory' })
            }
          })
        }
      }
    },
    handleConfirmClick () {
      // console.log(this.factoryInfo.address)
      // console.log(this.address)
      let searchAddress = this.address + this.factoryInfo.address
      if (searchAddress) {
        console.log(searchAddress)
        // this.getLngLat(searchAddress)
        this.showMap(searchAddress)
      }
      // this.geoCode()
    },
    handleCancelClick () { // 取消
      this.$router.push({ path: '/manage/factory' })
      // console.log(this.options)
      //   this.$store.commit('factory/showAddFactory', false)
    },
    showMap (address) {

      var map = new AMap.Map('container', {
        resizeEnable: true,
        zoom: this.zoom
      })
      AMap.service("AMap.Geocoder", res => {
        var geocoder, marker
        if (!geocoder) {
          geocoder = new AMap.Geocoder({
            city: '全国', // 城市设为北京，默认：“全国”
          })
        }
        geocoder.getLocation(address, (status, result) => {

          if (status === 'complete' && result.geocodes.length) {
            var lnglat = result.geocodes[0].location
            this.factoryInfo.lng = lnglat.lng
            this.factoryInfo.lat = lnglat.lat
            if (!marker) {
              marker = new AMap.Marker

              map.add(marker)
            }
            marker.setPosition(lnglat)
            map.setFitView(marker)
            console.log(lnglat)
          } else {
            this.$alert('请输入正确的地址', {
              confirmButtonText: '确定',
            });
          }

          // }
          // function (status, result) {

          // console.log('aaa', addr, status, result)
          // if (status === 'complete' && result.geocodes.length) {
          //   console.log(lnglat)
          //   // document.getElementById('lnglat').value = lnglat
          // } else {
          //   console.log('根据地址查询位置失败')
          // }
        })
      })
    },

  },
  mounted () {
    this.initData()

    this.id = this.$route.query.item
    if (this.id) {
      this.getData(this.id)
      this.titlename = '修改'
      this.changeAddr = true
      // this.showMap(this.factoryInfo.address)
    } else {
      this.showMap('天安门')
    }
  }

}
</script>
<style lang="stylus">
.addfactory
  // overflow-y auto
  width calc(100% - 40px)
  height calc(100% - 20px)
  background #fff
  margin 0 20px
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 67px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    overflow-y auto
    height calc(100% - 50px)
    .addFactoryInfo
      height 46px
      // background #f66
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../../assets/images/03/add_icon.png') no-repeat center left 15px
    .factoryContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      // overflow-y auto
      border-top 1px solid #CFD5DC
      // border-bottom 1px solid #CFD5DC
      .factorylist
        margin-top 26px
        position relative
        label
          width 154px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
        .el-input
          width 308px
          margin-left 12px
        .el-cascader__label
          padding 2px 25px 0 26px
        .areaaddress
          position absolute
          left 154px
          top 2px
      .address
        margin-left 154px
      .factoryBtn
        margin-left 116px
        margin-top 100px
        margin-bottom 20px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
      .map_content
        width 458px
        height 186px
        // background #f8f
        margin-left 166px
        #container
          width 100%
          height 100%
</style>
